import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

import { devicesConfig } from "./deviceDistributionConsts";
import type { IDeviceDistributionGraphItem, IDeviceDistributionResponseData } from "./deviceDistributionTypes";

const getShareSplit = (mobileShare: number, volume: number) => {
    if (!mobileShare && !volume) {
        return {
            [devicesTypes.DESKTOP]: 0,
            [devicesTypes.MOBILE]: 0,
        };
    }
    return {
        [devicesTypes.DESKTOP]: 1 - mobileShare,
        [devicesTypes.MOBILE]: mobileShare,
    };
};

export const getTransformedData = (
    data: IDeviceDistributionResponseData,
    keys: string,
): IDeviceDistributionGraphItem[] => {
    const shareSplit = getShareSplit(data?.Data[keys]?.MobileShare, data?.Data[keys]?.Volume);
    const transformedData = Object.entries(shareSplit).map(([key, value]) => {
        const config = devicesConfig.find((tier) => tier.id === key);
        return {
            name: config.name,
            color: config.color,
            y: value,
            total: value,
            visible: true,
            id: key,
        };
    });
    return transformedData;
};
